import axios from 'axios'
import { getToken } from './auth'

// 尝试导入store，如果失败则不使用
let store
try {
    store = require('../stores/store').default
} catch (e) {
    console.warn('Store import failed:', e)
    store = { getters: {} }
}

// create an axios instance
const service = axios.create({
    //baseURL: 'https://www.aiavatar.top', // url = base url + request url
    baseURL: '/api', // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        const token = getToken()
        if (token) {
            // let each request carry token
            config.headers['chat-token'] = token
        }

        // 添加调试信息
        console.log('Request Config:', {
            url: config.url,
            method: config.method,
            params: config.params,
            data: config.data,
            headers: config.headers
        })

        return config
    },
    error => {
        // do something with request error
        console.log('Request Error:', error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // 添加调试信息
        console.log('Response Data:', {
            url: response.config.url,
            status: response.status,
            data: res
        })

        return res
    },
    error => {
        console.log('Response Error:', error) // for debug

        // 添加更详细的错误信息
        if (error.response) {
            console.log('Error Response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            })
        } else if (error.request) {
            console.log('Error Request:', error.request)
        } else {
            console.log('Error Message:', error.message)
        }

        return Promise.reject(error)
    }
)

export default service